// extracted by mini-css-extract-plugin
export var container = "_6h-0";
export var infoButton = "_6h-1";
export var label = "_6h-3";
export var labelExpanded = "_6h-4";
export var price = "_6h-5";
export var priceExpanded = "_6h-6";
export var title = "_6h-2";